import { createFileRoute } from "@tanstack/react-router";
import { FSRSSecondaryNav } from "../../../components/analytics/layout/FSRSSecondaryNav";
import { MainSidebar } from "../../../components/sidebars/MainSidebar";
import { SchoolSettingsPage } from "../../../pages/fsrs/SchoolSettingsPage";

function FSRSSchoolSettingsWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <FSRSSecondaryNav />
        <div className="flex-1 overflow-auto p-6">
          <SchoolSettingsPage />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/fsrs/schools")({
  component: FSRSSchoolSettingsWithSidebar,
});
